import { Box, Button, Chip } from '@mui/material';

interface SupportPolicyCategoryChipsProps {
  selectedCategories: string[];
  onRemoveCategory: (category: string) => void;
  onClearAll: () => void;
}

export const SupportPolicyCategoryChips = ({
  selectedCategories,
  onRemoveCategory,
  onClearAll,
}: SupportPolicyCategoryChipsProps) => {
  if (!selectedCategories.length) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 1,
        px: 2,
        py: 1,
      }}
    >
      {selectedCategories.map((category) => (
        <Chip
          key={category}
          label={category}
          size="small"
          onDelete={() => onRemoveCategory(category)}
        />
      ))}
      <Button size="small" color="primary" onClick={onClearAll} sx={{ textTransform: 'none' }}>
        clear all
      </Button>
    </Box>
  );
};
